// Styling
import "./main.scss";

console.log("main")

/**
 * Importing of non-vue scripts
 * When `init()` is called, the necessary listeners and logic is applied to any relevant organisms and their atoms and/or molecules
 */
import TpxAuthorUtils from "./components/organisms/author/author.utils";
import TpxCallToActionUtils from "./components/organisms/call-to-action/call-to-action.utils";
import TpxCardsUtils from "./components/organisms/cards/cards.utils";
import TpxFeatureUtils from "./components/organisms/feature/feature.utils";
import TpxFormUtils from "./components/organisms/form/form.utils";
import TpxListUtils from "./components/organisms/list/list.utils";
import TpxNavigationBarUtils from "./components/organisms/navigation-bar/navigation-bar.utils";
import TpxQuoteUtils from "./components/organisms/quote/quote.utils";
import TpxServicesUtils from "./components/organisms/services/services.utils";
import TpxShareUtils from "./components/organisms/share/share.utils";
import TpxSocialLinksUtils from "./components/molecules/social/social-links.utils";
import TpxSignposting from "./components/organisms/signposting/signposting.utils";
import TpxVideoUtils from "./components/organisms/video/video.utils";
import TpxIconGridUtils from "./components/organisms/icon-grid/iconGrid.utils";
import TpxFurtherReadingUtils from './components/organisms/further-reading/further-reading.utils';
import TpxKnowledgeHero from './components/organisms/knowledge-hero/knowledge-hero.utils';
import TpxShowcaseUtils from './components/organisms/showcase/showcase.utils';
import TpxClientShowcaseUtils from './components/organisms/client-showcase/client-showcase.utils';
import TpxQuoteCarouselBlock from './components/organisms/quote-carousel-block/quote-carousel-block.utils';
import TpxListingHeroUtils from "./components/organisms/listing-hero/listing-hero.utils";
import TpxHubsUtils from "./components/organisms/hubs/hubs.utils";
import TpxWave from "./components/organisms/wave/wave.utils";

//V2
import TpxVideosUtils from "./v2/components/videos/videos.utils";
import TpxsidebarNewsletterSubscriptionUtils from "./v2/components/sidebar/sidebar-newsletter-subscription.utils";

TpxAuthorUtils.init();
TpxCallToActionUtils.init();
TpxCardsUtils.init();
TpxFeatureUtils.init();
TpxFormUtils.init();
TpxListUtils.init();
TpxNavigationBarUtils.init();
TpxQuoteUtils.init();
TpxServicesUtils.init();
TpxShareUtils.init();
TpxSocialLinksUtils.init();
TpxSignposting.init();
TpxVideoUtils.init();
TpxVideosUtils.init();
TpxIconGridUtils.init();
TpxKnowledgeHero.init();
TpxFurtherReadingUtils.init();
TpxShowcaseUtils.init();
TpxClientShowcaseUtils.init();
TpxQuoteCarouselBlock.init();
TpxListingHeroUtils.init();
TpxHubsUtils.init();
TpxWave.init();
TpxsidebarNewsletterSubscriptionUtils.init();



/**
 * Importing Vue components
 * This example creates a new Vue app for every `.o-list--vue` element on the page
 */
import { createApp } from "vue";
import TpxNewsLandingHero from "./components/organisms/news-landing-hero/news-landing-hero.vue";
import TpxNewsListingBlock from "./components/organisms/news-listing-block/news-listing-block.vue";
import TpxList from "./components/organisms/list/list.vue";
import TpxAccordionGroup from "./components/molecules/accordion-group/accordion-group.vue";

[...document.querySelectorAll('[data-component="NewsLandingHero"]')].forEach((hero) => {
    let dataset = (hero as HTMLElement).dataset;
    if (dataset.args) {
        dataset = {
            ...dataset,
            ...JSON.parse(
                document.getElementById(dataset.args)?.innerText?.trim()
            ),
        };
    }

    createApp(TpxNewsLandingHero, dataset).mount(hero);
});

[...document.querySelectorAll('[data-component="NewsListingBlock"]')].forEach((hero) => {
    let dataset = (hero as HTMLElement).dataset;
    if (dataset.args) {
        dataset = {
            ...dataset,
            ...JSON.parse(
                document.getElementById(dataset.args)?.innerText?.trim()
            ),
        };
    }

    createApp(TpxNewsListingBlock, dataset).mount(hero);
});

[...document.getElementsByClassName("o-list--vue")].forEach((list) => {
    let dataset = (list as HTMLElement).dataset;
    if (dataset.args) {
        dataset = {
            ...dataset,
            ...JSON.parse(
                document.getElementById(dataset.args)?.innerText?.trim()
            ),
        };
    }

    createApp(TpxList, dataset).mount(list);
});

[...document.getElementsByClassName("m-accordion-group__wrapper")].forEach(
    (accordionGroup) => {
        let dataset = (accordionGroup as HTMLElement).dataset;
        if (dataset.accordions) {
            dataset = {
                ...dataset,
                ...JSON.parse(
                    document
                        .getElementById(dataset.accordions)
                        ?.innerText?.trim()
                ),
            };
        }

        createApp(TpxAccordionGroup, dataset).mount(accordionGroup);
    }
);


//[...document.getElementsByClassName('m-accordion-group')].forEach(accordion => {
//    let dataset = (accordion as HTMLElement).dataset;
//    if (dataset.args) {
//        dataset = {
//            ...dataset,
//            ...JSON.parse(document.getElementById(dataset.args)?.innerText?.trim()),
//        };
//    }

//    createApp(TpxAccordion, dataset).mount(accordion)
//});

